import React from 'react'

function NumberCircle({color,children}) {
  return (
    <div style={{
      align:'center',
        color: '#000',
        border: '4px solid #ccc',
        borderRadius: '50%',
        borderColor:`${color}`,
        fontSize: '.6rem',
        fontWeight:'bold',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '3em',
        height: '3em',
        marginLeft:'20px'
      }}
    >{children}</div>
  )
}

export default NumberCircle